import { BaseResponse } from '@/_metronic/helpers/crud-helper/base-list-response'

export interface FilterDashboardHR {
  set_brand_id?: boolean;
  brand_id?: string[];
  set_sub_brand_id?: boolean;
  sub_brand_id?: string[];
  set_outlet_id?: boolean;
  outlet_id?: string[];
  years?: number;
  months?: number[];
  page?: number;
  limit?: number;
}

export interface DashboardAttendanceLog {
  check_in_time?: string;
  attendance_name?: string;
}

export interface DashboardActiveEmployee {
  months?: number;
  years?: number;
  active_employee_count?: number;
}

export interface DashboardJobTitle {
  job_id?: string;
  job_title?: string;
  total?: number;
  percentage?: number;
}

export interface DashboardContractType {
  contract_type?: string;
  total?: number;
  percentage?: number;
}

export interface DashboardAverageAge {
  age_range?: string;
  total?: number;
}

export interface DashboardContractCurrentMonth {
  guid?: string;
  employee_guid?: string;
  employee_data?: EmployeeData;
  outlet_guid?: string;
  outlet_data?: OutletData;
  brand_guid?: string;
  brand_name?: string;
  sub_brand_guid?: null;
  sub_brand_name?: null;
  contract_type?: string;
  department?: string;
  job_title?: string;
  job_level?: string;
  join_date?: Date;
  start_of_contract?: Date;
  end_of_contract?: Date;
  length_of_contract?: string;
  contract_status?: string;
  status?: string;
  file_upload?: null;
  basic_salary?: number;
  allowances?: null;
  company?: null;
  created_at?: Date;
  created_by?: string;
  updated_at?: Date;
  updated_by?: string;
}

export interface EmployeeData {
  guid?: string;
  fullname?: string;
  nickname?: string;
  date_of_birth?: Date;
  gender?: string;
  address_id_card?: string;
  address_domicile?: string;
  marital_status?: string;
  education?: string;
  email?: string;
  phone_number?: string;
  id_card?: string;
  npwp?: string;
  join_date?: Date;
  nik?: string;
  bank_name?: string;
  bank_account?: string;
  insurance_number?: string;
  insurance_institution?: null;
  bpjs_ketenagakerjaan?: string;
  url_profile_picture?: string;
  about_me?: string;
  skills?: string[];
  interests?: string;
  expertise?: string;
  cv_file_url?: string;
  url_social_media?: URLSocialMedia[];
  job_id?: string;
  department_id?: string;
  outlet_id?: string;
  sub_brand_id?: string;
  brand_id?: string;
  group_id?: string;
  status?: string;
  created_at?: Date;
  created_by?: string;
  updated_at?: Date;
  updated_by?: string;
}

export interface URLSocialMedia {
  url?: string;
  platform?: string;
  usernames?: string;
}

export interface OutletData {
  guid?: string;
  group_id?: null;
  group_name?: string;
  brand_id?: string;
  brand_name?: string;
  sub_brand_id?: string;
  sub_brand_name?: string;
  outlet_code?: string;
  name?: string;
  area?: string;
  region_id?: string;
  region_name?: string;
  city_id?: string;
  city_name?: string;
  address?: null;
  phone_number?: string;
  email?: null;
  url_website?: null;
  url_instagram?: null;
  url_tiktok?: null;
  description?: null;
  image_url?: null;
  created_at?: Date;
  created_by?: string;
  updated_at?: Date;
  updated_by?: string;
}


export type DashboardAttendanceLogQueryResponse = BaseResponse<DashboardAttendanceLog[]>
export type DashboardActiveEmployeeQueryResponse = BaseResponse<DashboardActiveEmployee[]>
export type DashboardJobTitleQueryResponse = BaseResponse<DashboardJobTitle[]>
export type DashboardContractTypeResponse = BaseResponse<DashboardContractType[]>
export type DashboardAverageAgeQueryResponse = BaseResponse<DashboardAverageAge[]>
export type DashboardContractCurrentMonthQueryResponse = BaseResponse<DashboardContractCurrentMonth[]>

const currentDate = new Date()
export const initialFilter: FilterDashboardHR = {
  set_brand_id: false,
  brand_id: [],
  set_sub_brand_id: false,
  sub_brand_id: [
  ],
  set_outlet_id: false,
  outlet_id: [],
  years: currentDate.getFullYear(),
  months: [],
  page: 1,
  limit: 10
}
